import React from 'react';
import HojaLifecycle from '../../assets/images/Lifecycle_Hoja_512x512.png';

// Distribución fija y estética de hojas
const hojasDistribucion = [
  { top: '5%', left: '10%', size: 90, rotate: -15, opacity: 0.13 },
  { top: '12%', left: '70%', size: 70, rotate: 22, opacity: 0.11 },
  { top: '30%', left: '40%', size: 110, rotate: -30, opacity: 0.14 },
  { top: '60%', left: '20%', size: 80, rotate: 8, opacity: 0.10 },
  { top: '80%', left: '60%', size: 100, rotate: 35, opacity: 0.13 },
  { top: '50%', left: '80%', size: 75, rotate: -22, opacity: 0.12 },
  { top: '75%', left: '30%', size: 95, rotate: 12, opacity: 0.10 },
  { top: '40%', left: '75%', size: 60, rotate: 18, opacity: 0.09 },
  { top: '10%', left: '50%', size: 85, rotate: -8, opacity: 0.12 },
  { top: '85%', left: '10%', size: 100, rotate: 27, opacity: 0.13 },
  { top: '20%', left: '25%', size: 65, rotate: 5, opacity: 0.10 },
  { top: '65%', left: '55%', size: 90, rotate: -18, opacity: 0.11 },
  { top: '35%', left: '15%', size: 80, rotate: 30, opacity: 0.13 },
  { top: '55%', left: '65%', size: 100, rotate: -12, opacity: 0.12 },
  { top: '78%', left: '80%', size: 70, rotate: 15, opacity: 0.10 },
  { top: '25%', left: '80%', size: 60, rotate: -25, opacity: 0.09 },
  { top: '15%', left: '30%', size: 100, rotate: 10, opacity: 0.13 },
  { top: '70%', left: '45%', size: 85, rotate: -20, opacity: 0.11 },
  { top: '45%', left: '60%', size: 95, rotate: 17, opacity: 0.12 },
  { top: '60%', left: '75%', size: 80, rotate: -10, opacity: 0.10 },
  // Más hojas agregadas para mayor densidad
  { top: '8%', left: '30%', size: 60, rotate: 8, opacity: 0.09 },
  { top: '18%', left: '80%', size: 90, rotate: -18, opacity: 0.12 },
  { top: '38%', left: '60%', size: 75, rotate: 20, opacity: 0.10 },
  { top: '55%', left: '10%', size: 100, rotate: -10, opacity: 0.13 },
  { top: '72%', left: '20%', size: 85, rotate: 15, opacity: 0.11 },
  { top: '90%', left: '40%', size: 95, rotate: -12, opacity: 0.12 },
  { top: '80%', left: '85%', size: 70, rotate: 25, opacity: 0.10 },
  { top: '60%', left: '50%', size: 60, rotate: -20, opacity: 0.09 },
  { top: '30%', left: '85%', size: 100, rotate: 10, opacity: 0.13 },
  { top: '45%', left: '35%', size: 80, rotate: -15, opacity: 0.11 },
  { top: '20%', left: '60%', size: 90, rotate: 18, opacity: 0.12 },
  { top: '75%', left: '55%', size: 100, rotate: -8, opacity: 0.13 },
  { top: '65%', left: '80%', size: 85, rotate: 12, opacity: 0.10 },
  { top: '10%', left: '85%', size: 95, rotate: -22, opacity: 0.12 },
  { top: '90%', left: '70%', size: 80, rotate: 17, opacity: 0.10 },
  { top: '55%', left: '25%', size: 100, rotate: -10, opacity: 0.13 },
  { top: '35%', left: '60%', size: 85, rotate: 20, opacity: 0.11 },
  { top: '25%', left: '55%', size: 95, rotate: -18, opacity: 0.12 },
  { top: '60%', left: '35%', size: 80, rotate: 15, opacity: 0.10 },
];

export const FallingLeavesBackground: React.FC = () => (
  <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    pointerEvents: 'none',
    zIndex: 1,
    overflow: 'hidden',
  }}>
    {hojasDistribucion.map((leaf, i) => (
      <img
        key={i}
        src={HojaLifecycle}
        alt="hoja fondo"
        style={{
          position: 'absolute',
          top: leaf.top,
          left: leaf.left,
          width: `${leaf.size}px`,
          opacity: leaf.opacity,
          transform: `rotate(${leaf.rotate}deg)`
        }}
      />
    ))}
  </div>
);
